import React from 'react';
import cx from 'classnames';
import type { Dayjs } from 'dayjs';
import styles from './WeddingDateVerticalDouble.module.less';
import type { WeddingDateVariantProps } from '../types';
import { WeddingDateDisplayFormatEnum } from '../../../../../../../util/websiteDateUtil';

const WeddingDateVerticalDouble = ({ websiteDate }: WeddingDateVariantProps): JSX.Element => {
  const renderDate = (d?: Dayjs) =>
    d ? (
      <>
        <h4 className="day-month">{d.format('dddd')}</h4>
        <span className="big-initial day">{d.format('M')}</span>
        <h4>/</h4>
        <span className="big-initial month">{d.format('D')}</span>
        <h4>{d.format('YYYY')}</h4>
      </>
    ) : null;

  const renderRangeDate = (d?: Dayjs) =>
    d ? (
      <div className={styles.rangeDateContainer}>
        <h4 className="day-month">{d.format('dddd')}</h4>
        <div className="big-initial">
          <span className="big-initial day">{d.format('M')}</span>
          <span className={styles.rangeDateDivider}>.</span>
          <span className="big-initial month">{d.format('D')}</span>
        </div>
        <h4>{d.format('YYYY')}</h4>
      </div>
    ) : null;

  const renderDateFormat = (): React.ReactNode => {
    if (websiteDate.displayFormat === WeddingDateDisplayFormatEnum.CUSTOM) {
      return <h4 className="location">{websiteDate.customDateMessage}</h4>;
    }
    if (websiteDate.displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
      const { weddingDateRangeStart, weddingDateRangeEnd } = websiteDate || {};
      return (
        <div>
          {renderRangeDate(weddingDateRangeStart)}
          <h4 className={cx('on', styles.rangeTo)}>to</h4>
          {renderRangeDate(weddingDateRangeEnd)}
        </div>
      );
    }
    return renderDate(websiteDate?.weddingDate);
  };

  return <div className={cx('wedding-info-column wedding-info-right')}>{renderDateFormat()}</div>;
};

export default WeddingDateVerticalDouble;
